import {view, Icon, tokens} from '@sail/ui';
import type {IconAsset} from '@sail/icons/types';

type AssetWithNetworkIconProps = {
  assetIcon: IconAsset;
  networkIcon?: IconAsset;
};

export const AssetWithNetworkIcon = ({
  assetIcon,
  networkIcon,
}: AssetWithNetworkIconProps) => {
  return (
    <view.div
      css={{
        stack: 'z',
        width: 'space.500',
        height: 'space.500',
      }}
    >
      <Icon
        icon={assetIcon}
        css={{
          width: 'fill',
          height: 'fill',
          borderRadius: '50%',
        }}
      />
      {networkIcon ? (
        <Icon
          icon={networkIcon}
          css={{
            alignSelfX: 'end',
            alignSelfY: 'top',
            width: '15px',
            height: '15px',
            marginTop: '-4px',
            marginRight: '-4px',
            borderRadius: 'xsmall',
            borderWidth: '1.5px',
            borderStyle: 'solid',
            borderColor: tokens.color.neutral[0].toString(),
          }}
        />
      ) : null}
    </view.div>
  );
};
